module.exports = __webpack_public_path__ + "61fed021937f6d89447436f70a8bb5fa.svg";